//====================================================
//  Function: Slider
//====================================================
function swiperChecker() {
  if ($(".js-slider-products-favorite").length) {
    (function () {
      "use strict";

      const breakpoint = window.matchMedia("(min-width:768px)");
      const breakpointChecker = function () {
        if (breakpoint.matches === false) {
          if (mySwiper !== undefined) mySwiper.destroy(true, true);
          return;
        } else if (breakpoint.matches === true) {
          return productFavoriteSlider();
        }
      };
      breakpoint.addListener(breakpointChecker);
      breakpointChecker();
    })();
  }

  (function () {
    "use strict";

    const breakpointGeneral = window.matchMedia("(min-width:768px)");
    const breakpointGeneralChecker = function () {
      if (breakpointGeneral.matches === false) {
        // $(".navigation-in > ul > li:first-child").addClass("exp");
        // $("body").addClass("submenu-visible");
        $("#header .search").insertBefore(
          $("#navigation .navigation-in .menu-level-1")
        );
        return;
      } else if (breakpointGeneral.matches === true) {
        // $("body").removeClass("submenu-visible");
        // $(".navigation-in > ul > li:first-child").removeClass("exp");
        $("#header .search").insertBefore($("#header .navigation-buttons"));
        return;
      }
    };
    breakpointGeneral.addListener(breakpointGeneralChecker);
    breakpointGeneralChecker();
  })();
}
